// import PDFViewerRenderer from "./dist/i-pdf-viewer.esm";
// import "./dist/i-pdf-viewer.css"

import PDFViewerRenderer from "@i-components/i-pdf-viewer";
import "@i-components/i-pdf-viewer/dist/i-pdf-viewer.css"

import {
  EventBus,
  PDFViewer,
  PDFLinkService,
  PDFFindController,
} from "pdfjs-dist/web/pdf_viewer";
import "pdfjs-dist/web/pdf_viewer.css";
import { getDocument,GlobalWorkerOptions } from "pdfjs-dist/lib/pdf";
import PdfjsWorker from "pdfjs-dist/lib/pdf.worker";
export function setPdfWorker(workerSrcOrClass) {
  if (typeof window !== "undefined") delete window.pdfjsWorker;
  delete GlobalWorkerOptions.workerSrc;
  delete GlobalWorkerOptions.workerPort;

  if (typeof workerSrcOrClass === "string") {
    GlobalWorkerOptions.workerSrc = workerSrcOrClass;
  } else if (typeof workerSrcOrClass === "function") {
    GlobalWorkerOptions.workerPort = workerSrcOrClass();
  } else if (workerSrcOrClass instanceof Worker) {
    GlobalWorkerOptions.workerPort = workerSrcOrClass;
  } else if (typeof window !== "undefined" && workerSrcOrClass) {
    window.pdfjsWorker = workerSrcOrClass;
  }
}
setPdfWorker(PdfjsWorker);

export default function(Vue){
  Vue.use(PDFViewerRenderer({
    prefix:"iv-",
    pdfLib: {
      getDocument,
      EventBus,
      PDFViewer,
      PDFLinkService,
      PDFFindController,
    }
  }))
}
